// extracted by mini-css-extract-plugin
export default {"login":"login_login__lRHQU","button":"login_button__ew1Qz","havent":"login_havent__4rQDq","forgot_password":"login_forgot_password__z9MVr"};